// Public order-id contract.
// New CareCard orders use 16 characters from the unambiguous 32-symbol alphabet.
// During migration, lookup/cancellation continues to accept exact legacy 12-character
// ids without teaching 12-character ids to new customers.
export const ORDER_ID_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
export const CURRENT_ORDER_ID_LENGTH = 16;
export const LEGACY_ORDER_ID_LENGTH = 12;
export const ORDER_ID_EXAMPLE = "ABCD2345EFGH6789";

const CURRENT_RE = new RegExp(`^[${ORDER_ID_ALPHABET}]{${CURRENT_ORDER_ID_LENGTH}}$`);
const LEGACY_RE = new RegExp(`^[${ORDER_ID_ALPHABET}]{${LEGACY_ORDER_ID_LENGTH}}$`);

export function normalizeOrderId(value) {
  return String(value || "").trim().toUpperCase();
}

export function isCurrentOrderId(value) {
  return CURRENT_RE.test(normalizeOrderId(value));
}

export function isLookupOrderId(value) {
  const normalized = normalizeOrderId(value);
  return CURRENT_RE.test(normalized) || LEGACY_RE.test(normalized);
}
